document.addEventListener('DOMContentLoaded', function () {
const accordions = document.querySelectorAll('.wp-block-gg-blocks-accordion-item');


  accordions.forEach((accordion) => {
    const header = accordion.querySelector('.gg-accordion__header');
    const content = accordion.querySelector('.gg-accordion__content');

    if (header && content) {
      header.addEventListener('click', function () {
        accordion.classList.toggle('open');
      });
    }
  });
});


